import { render, staticRenderFns } from "./KSurveyQuestion.vue?vue&type=template&id=210eca5c"
import script from "./KSurveyQuestion.vue?vue&type=script&lang=js"
export * from "./KSurveyQuestion.vue?vue&type=script&lang=js"
import style0 from "./KSurveyQuestion.vue?vue&type=style&index=0&id=210eca5c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports